import { RootState } from '../../data/store'

export const getReconcilerState = (state: RootState) => state?.reconciler
